module.exports = __webpack_public_path__ + "static/payless-supplements-23dc3c0fef71bc22ad57fd2fd6e60171.png";